<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listAccountPlans"
        :title-table="$t('Account Plan')"
        module="accountPlanSettingsModule"
        sort-name="classe"
        add-permission="ROLE_PLANO_DE_CONTA_INSERIR"
        view-permission="ROLE_PLANO_DE_CONTA_CONSULTAR"
        edit-permission="ROLE_PLANO_DE_CONTA_ATUALIZAR"
        delete-permission="ROLE_PLANO_DE_CONTA_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormAccountPlan v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import FormAccountPlan from "./forms/FormAccountPlan.vue";

export default {
  name: "AccountPlan",
  components: {
    BRow,
    BCol,
    TableComponents,
    FormAccountPlan,
  },
  computed: {
    ...mapState("accountPlanSettingsModule", {
      listAccountPlans: (state) => state.listAccountPlans,
    }),
  },
  // mixins: [mixinsGlobal],
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: this.$t("id"),
          field: "id",
        },
        {
          label: "Classe",
          field: "classe",
        },
        {
          label: "Natureza",
          field: "codNatureza",
        },
        {
          label: this.$t("Action"),
          field: "action",
        },
      ],
    };
  },
  methods: {
    addNew() {
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch(
        "accountPlanSettingsModule/prepareToEditAccountPlan",
        data,
      );
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
    },
  },
};
</script>
